export default function ReassignmentTargetSelect({
  options,
  value,
  onChange,
  disabled = false,
  placeholder = "Select a user",
}) {
  return (
    <select
      value={value}
      disabled={disabled}
      onChange={(e) => onChange?.(e.target.value)}
      style={{
        width: "100%",
        padding: "10px 12px",
        fontSize: "14px",
        borderRadius: "4px",
        border: "1px solid var(--border-bright)",
        background: "var(--bg-elevated)",
        color: "var(--text-primary)",
        fontFamily: "inherit",
      }}
    >
      <option value="">{placeholder}</option>
      {(options || []).map((u) => (
        <option key={u.id} value={u.id}>
          {u.label}
        </option>
      ))}
    </select>
  );
}
